module.exports = __webpack_public_path__ + "static/media/logo_notext.1e415cb5.png";